import type { MittwaldAPIV2Client } from "@mittwald/api-client-NEXT";
import { assertStatus } from "@mittwald/api-client-NEXT";
import type { SshUserBehaviors } from "./types.js";
import { checkForValidationErrors } from "../../../base/index.js";

export const apiSshUserBehaviors = (
  client: MittwaldAPIV2Client,
): SshUserBehaviors => ({
  find: async (sshUserId) => {
    const response = await client.sshsftpUser.sshUserGetSshUser({ sshUserId });

    if (response.status === 200) {
      return response.data;
    }
    assertStatus(response, 404);
  },

  list: async (projectId, query) => {
    const response = await client.sshsftpUser.sshUserListSshUsers({
      queryParameters: query,
      projectId,
    });

    assertStatus(response, 200);

    return {
      items: response.data,
    };
  },

  create: async (projectId, data) => {
    const response = await client.sshsftpUser.sshUserCreateSshUser({
      projectId,
      data,
    });

    const validationErrors = checkForValidationErrors(response);
    if (validationErrors) {
      return validationErrors;
    }

    assertStatus(response, 201);

    return response.data;
  },

  update: async (sshUserId, data) => {
    const response = await client.sshsftpUser.sshUserUpdateSshUser({
      sshUserId,
      data,
    });

    const validationErrors = checkForValidationErrors(response);
    if (validationErrors) {
      return validationErrors;
    }

    assertStatus(response, 204);
  },

  delete: async (sshUserId) => {
    const response = await client.sshsftpUser.sshUserDeleteSshUser({
      sshUserId,
    });

    assertStatus(response, 204);
  },
});
